import moment from 'moment'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import VueRangeDatepicker from './components/VueRangeDatepicker.vue'

export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      valueStart: this.modelProps[this.config.startDateFieldName] && this.modelProps[this.config.startDateFieldName] instanceof firebase.firestore.Timestamp ? this.modelProps[this.config.startDateFieldName].toDate() : '',
      valueEnd: this.modelProps[this.config.endDateFieldName] && this.modelProps[this.config.endDateFieldName] instanceof firebase.firestore.Timestamp ? this.modelProps[this.config.endDateFieldName].toDate() : '',
      value: ''
    }
  },
  created () {
    if (this.valueStart && this.valueEnd) {
      this.value = `${moment(this.valueStart).format(this.$store.state.config.defaultDateFormat)} ~ ${moment(this.valueEnd).format(this.$store.state.config.defaultDateFormat)}`
    }
  },
  watch: {
    valueStart (newVl) {
      let modelSubmit = {}
      modelSubmit[this.config.startDateFieldName] = newVl
      this.modelProps[this.config.startDateFieldName] = firebase.firestore.Timestamp.fromDate(new Date(moment.utc(newVl, this.$store.state.config.defaultDateFormat).format()))
    },
    valueEnd (newVl) {
      let modelSubmit = {}
      modelSubmit[this.config.endDateFieldName] = newVl
      this.modelProps[this.config.endDateFieldName] = firebase.firestore.Timestamp.fromDate(new Date(moment.utc(newVl, this.$store.state.config.defaultDateFormat).format()))
    },
    value (newValue) {
      let splited = newValue.split('~')
      if (splited.length > 1) {
        this.valueStart = splited[0]
        this.valueEnd = splited[1]
      } else {
        this.valueStart = splited[0]
        this.valueEnd = splited[0]
      }
    }
  },
  methods: {
    validate () {
      this.$refs[this._uid].validate()
    }
  },
  components: {
    VueRangeDatepicker
  }
}
